import { SecondarySectionStyles } from '../../styles/styles';

type Prop = {
  secondary: string[];
};

const SecondarySection = (props: Prop) => {
  const { secondary } = props;
  return (
    <SecondarySectionStyles data-scroll-section>
      <div className="content">
        {secondary.map((text, index) => {
          return <h2 key={index}>{text}</h2>;
        })}
      </div>
    </SecondarySectionStyles>
  );
};

export default SecondarySection;
